import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

interface SettingsButtonProps {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  onClick?: () => void;
  variant?: "default" | "destructive";
}

export function SettingsButton({
  icon: Icon,
  label,
  onClick,
  variant = "default",
}: SettingsButtonProps) {
  return (
    <Button
      variant={variant === "destructive" ? "outline" : "outline"}
      size="pill-lg"
      onClick={onClick}
      className={`w-full justify-between ${
        variant === "destructive"
          ? "border-red-400 text-red-700 dark:border-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/20"
          : "dark:bg-auth-background"
      }`}
      rightIcon={<ChevronRight className="w-4 h-4" />}
    >
      <div className="flex items-center space-x-2">
        <Icon className="w-4 h-4" />
        <span>{label}</span>
      </div>
    </Button>
  );
}
